import type { Config } from './types';

export const config: Config = {
  env: 'production',
  variant: {
    tvOSBundleId: 'com.creativelabs.fit52',
    androidPackageName: {
      default: 'com.creativelabs.fit52tv',
      play: 'com.creativelabs.fit52',
    },
    name: 'HiNote Life TV',
  },
  api: { baseURL: 'https://backend.fit52life.com/api' },
  pairingLink: { baseURL: 'https://go.hinote.com' },
  downloadLink: { baseURL: 'https://go.hinote.com' },
  unlockCode: null,
  shouldInitializeSentry: true,
  enableLogsStreamByDefault: false,
  sentry: {
    dsn: 'https://c0aec1ba263f5932ea1a6b45a54c5bfe@o249262.ingest.us.sentry.io/4511254172663808',
    project: 'fit52-tv-web-production',
  },
};
